module.exports = __webpack_public_path__ + "static/media/visa-logo.66ba4b3e.svg";